export const state = () => ({
  isOverlayActive: false,
  isModalActive: false,
  modalContent: '',
  isPageTransitionActive: false,
  layout: '',
  isLogoWhite: true
});

export const mutations = {
  toggleOverlay(state, value) {
    state.isOverlayActive = value;
  },
  setModalContent(state, value) {
    state.modalContent = value;
  },
  setLogoColor(state, value) {
    state.isLogoWhite = value;
  },
  toggleModal(state, value) {
    if (value === false) {
      state.modalContent = '';
    }
    state.isModalActive = value;
  },
  startPageTransitionAnimation(state) {
    state.isPageTransitionActive = true;
  },
  stopPageTransitionAnimation(state) {
    state.isPageTransitionActive = false;
  },
  setPageLayout(state, layout) {
    state.layout = layout;
  }
};

export const getters = {
  isLogoWhite(state) {
    return state.isLogoWhite;
  },
  isOverlayActive(state) {
    return state.isOverlayActive;
  },
  isModalActive(state) {
    return state.isModalActive;
  },
  getModalContent(state) {
    return state.modalContent;
  },
  isLoaderActive(state) {
    return state.isLoaderActive;
  },
  isPageTransitionActive(state) {
    return state.isPageTransitionActive;
  },
  getPageLayout(state) {
    return state.layout;
  }
};
